export function buildDashboardSearchParams(filters) {
    var params = new URLSearchParams();
    Object.entries(filters !== null && filters !== void 0 ? filters : {}).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        if (Array.isArray(value)) {
            value.filter(Boolean).forEach(function (item) { return params.append(key, item); });
            return;
        }
        if (value) {
            params.set(key, value);
        }
    });
    return params;
}
